import { useDrag } from "react-dnd";
import Badge from "react-bootstrap/Badge";

function Letters(props) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "letter",
    item: { id: props.id, name: props.name },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));
  return (
    <Badge
      bg="info"
      text="dark"
      ref={drag}
      key={props.id}
      id={props.id}
      variant="outline-primary"
      style={{
        marginTop: "5px",
        height: "80px",
        width: "55px",
        margin: "10px",
        paddingTop: "22px",
        borderRadius: "15px",
        border: isDragging ? "2px solid #e7b8ff" : "2px solid #333",
      }}
    >
      <h5
        style={{
          color: isDragging ? "#e7b8ff" : "#fff",
        }}
      >
        {props.name}
      </h5>
    </Badge>
  );
}
export default Letters;
